import { TrafficResult } from '@apm/contracts';
import { toQuery } from '../api';
import { usePolling } from '../hooks/usePolling';
import { useQuery } from '../hooks/useQuery';

/**
 * 트레이스만 서비스의 1분 집계 조회 (34회차).
 *
 * 실시간 연결(SSE)로 밀지 않고 **30초마다 다시 읽는다.** 구간이 1분이라 그보다 자주 받을
 * 값이 없고, 서비스 목록 갱신 주기와 같아 화면 두 곳의 숫자가 크게 어긋나지 않는다.
 * SSE로 밀 것인가는 실제 사용을 보고 정한다.
 */

const REFRESH_MS = 30_000;

export function useTraffic(service: string, minutes?: number) {
  // 탭이 숨은 동안은 쉰다 (44회차)
  const version = usePolling(REFRESH_MS);
  return useQuery(
    service === '' ? undefined : `/api/rt/traffic${toQuery({ service, minutes })}`,
    TrafficResult,
    version,
  );
}
